/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-unused-vars */
import { AccountVariationsConfig } from '@nizza/core';
import { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import type {
  PlayerProduct,
  PlayerProductImage,
  PlayerVariationSelector,
  PlayerVariationValues,
} from '../../../types';
import { getElementById, querySelectorAll } from '../../../utils';
import { isColor } from '../utils';
import styles from './styles.module.css';

type ColorVariationProps = {
  product: PlayerProduct;
  setSelectedColor: Dispatch<SetStateAction<PlayerVariationValues[]>>;
  variationThumbnailName?: string;
  roundOrSquareSelector?: 'round-selector' | 'square-selector';
  variationsConfig?: AccountVariationsConfig;
};

const roundSelector = 'round-selector';

export const ColorVariation = ({
  product,
  setSelectedColor,
  variationThumbnailName,
  roundOrSquareSelector,
  variationsConfig,
}: ColorVariationProps) => {
  const [colorArray, setColorArray] = useState<PlayerVariationSelector[]>([]);
  const [title, setTitle] = useState('');

  const nameOmittedVariations = variationsConfig?.omitted?.map(x =>
    x.toLowerCase(),
  );

  useEffect(() => {
    if (product?.variationSelector.length <= 0) return;

    let color = product?.variationSelector?.filter(
      item =>
        isColor(item.field.name) &&
        !(
          nameOmittedVariations &&
          nameOmittedVariations.includes(item.field.name.toLowerCase())
        ),
    );

    if (color && color.length > 0) {
      color = imagesMap(color);

      setColorArray(color);

      const colorFormatted = color.map(color => {
        return {
          id: color.values[0].id,
          name: color.values[0].name,
          variationId: color.field.id,
          variationName: color.field.name,
          image: color.values[0]?.image,
        };
      });

      setTitle(
        `${colorFormatted[0].variationName} : ${colorFormatted[0].name}`,
      );

      setSelectedColor(colorFormatted);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product?.variationSelector]);

  const handleColorSelect = (
    colorId: string,
    value: PlayerVariationValues,
    variation: number,
    variationName: string,
  ) => {
    value.variationId = variation;
    value.variationName = variationName;

    if (value) setSelectedColor([value]);

    const divSelect = getElementById(colorId);
    const divSelects = querySelectorAll('.divSelectSize');

    divSelects.forEach(item => {
      item.removeAttribute('style');
      item.setAttribute('style', 'display: none');
    });

    if (divSelect) divSelect.style.display = 'initial';

    setTitle(`${variationName} : ${value.name}`);
  };

  const imagesMap = (color: PlayerVariationSelector[]) => {
    const imagesColorVariations = {} as Record<
      string,
      PlayerProductImage[] | undefined
    >;

    const imageRegex = new RegExp(
      variationThumbnailName || 'skuvariation',
      'i',
    );

    for (let i = 0; i < product.items.length; i++) {
      const propsColor = Object.keys(product.items[i])?.filter(prop =>
        isColor(prop.toLowerCase()),
      );

      for (let j = 0; j < propsColor.length; j++) {
        const color =
          product.items[i][
          propsColor[j] as keyof (typeof product.items)[typeof i]
          ];

        if (color && color.length) {
          const colorName = (color[0] as string).toLowerCase();
          imagesColorVariations[colorName] = product.items[i].images;
        }
      }
    }

    for (let j = 0; j < color[0]?.values.length; j++) {
      const colorName = color[0]?.values[j]?.name.toLowerCase();

      const imagesColorProduct = imagesColorVariations[colorName];

      const variationImage = imagesColorProduct?.find(image => {
        if (!image?.imageLabel) {
          return false;
        }
        return imageRegex.test(image?.imageLabel);
      });

      if (variationImage) {
        color[0].values[j].image = variationImage;
      } else {
        if (imagesColorProduct) {
          color[0].values[j].image = imagesColorProduct[0];
        }
      }
    }

    return color;
  };

  return colorArray && colorArray.length > 0 ? (
    <Fragment>
      <h2 className={styles.titleVariation}>{title}</h2>
      <div className={styles.itemContent}>
        {colorArray.length > 0 &&
          colorArray[0].values.map((color, index) => (
            <div
              key={color.id}
              className={`${styles.itemColor} ${roundOrSquareSelector === roundSelector && styles.roundSelector
                }`}
            >
              <div
                id={color.id}
                className={`${styles.itemColorSelect} divSelectSize ${roundOrSquareSelector === 'round-selector' &&
                  styles.roundSelector
                  }`}
                style={
                  index === 0 ? { display: 'initial' } : { display: 'none' }
                }
              />
              <div
                onClick={() =>
                  handleColorSelect(
                    color.id,
                    color,
                    colorArray[0].field.id,
                    colorArray[0].field.name,
                  )
                }
                className={`${roundOrSquareSelector === roundSelector &&
                  styles.roundSelector
                  }`}
              >
                {/* Acá va el border radius */}
                {color?.image?.imageUrl ? (
                  <img
                    src={color.image.imageUrl}
                    alt={color.image.imageLabel as string | undefined}
                    style={{
                      height: `${roundOrSquareSelector === roundSelector
                          ? '30px'
                          : '60px'
                        }`,
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                    className={`${roundOrSquareSelector === roundSelector &&
                      styles.roundSelector
                      }`}
                  />
                ) : (
                  color.name
                )}
              </div>
            </div>
          ))}
      </div>
    </Fragment>
  ) : null;
};
